export enum SaveVariants {
  notSave = 0,
  stopAndSave = 1,
  saveAfterStop = 2
}
